import { useMutation } from "@tanstack/react-query";
import { toast } from "~served/ui-comps/toast";
import { setState } from "~/store";
import {
	CreateQrNotificationDocument,
	CreateQrNotificationMutationVariables,
} from "~/types/__generated/gql/graphql";
import { gqlReq } from "~/libs/gql";

void (
	/* GraphQL */ `
		mutation CreateQrNotification($input: CreateQrNotificationInput!) {
			createQrNotification(input: $input) {
				_id
				created_at
				updated_at
				content
			}
		}
	`
);

export const useSendAssistance = () => {
	return useMutation({
		mutationFn: (variables: CreateQrNotificationMutationVariables) =>
			gqlReq({
				document: CreateQrNotificationDocument,
				variables,
			}),
		onSuccess: () => {
			toast.info("Assistance sent! Hang tight for a minute or twos 😇");
			setState({ isNeededHelp: false });
		},
	});
};
